import { api } from '@/lib/api'
import type { Organisation } from './organisations'

export type Rol = 'superadmin' | 'admin' | 'user'

export interface Gebruiker {
  id: number
  gebruikersnaam: string
  volledige_naam?: string | null
  email?: string | null
  rol: Rol
  organisation_id?: number | null
  organisation_naam?: string | null
  actief: boolean
  laatste_login?: string | null
  created_at?: string | null
}

export interface BedrijfPayload {
  naam: string
  kvk?: string | null
  contactpersoon?: string | null
  email?: string | null
  telefoon?: string | null
  bederfelijke_waar?: string
  fin_pct_voorraad?: number
  fin_pct_emballage?: number
  fin_pct_verpakking?: number
  fin_pct_overig?: number
  min_houdbaarheidsdagen?: number
  actief?: boolean
}

export interface GebruikerPayload {
  gebruikersnaam: string
  volledige_naam?: string | null
  email?: string | null
  wachtwoord: string
  rol: Rol
  organisation_id?: number | null
  actief?: boolean
}

export interface Mutatie {
  id: number
  tijdstip: string
  gebruiker?: string | null
  pagina?: string | null
  actie?: string | null
  entiteit?: string | null
  identificatie?: string | null
  detail?: string | null
  organisation_id?: number | null
}

export interface LijstWaarde {
  id: number
  categorie: string
  waarde: string
  actief: boolean
}

// ── Bedrijven ────────────────────────────────────────────────────────
export const aanmakenBedrijf      = (data: BedrijfPayload) => api.post<Organisation>('/api/bedrijven', data).then(r => r.data)
export const bijwerkenBedrijf     = (id: number, data: Partial<BedrijfPayload>) => api.put<Organisation>(`/api/bedrijven/${id}`, data).then(r => r.data)
export const verwijderenBedrijf   = (id: number) => api.delete(`/api/bedrijven/${id}`)

// ── Gebruikers ───────────────────────────────────────────────────────
export const fetchGebruikers      = () => api.get<Gebruiker[]>('/api/gebruikers').then(r => r.data)
export const aanmakenGebruiker    = (data: GebruikerPayload) => api.post<Gebruiker>('/api/gebruikers', data).then(r => r.data)
export const bijwerkenGebruiker   = (id: number, data: Partial<Gebruiker> & {wachtwoord?: string}) => api.put<Gebruiker>(`/api/gebruikers/${id}`, data).then(r => r.data)
export const resetWachtwoord      = (id: number, nieuw_wachtwoord: string) => api.post<Gebruiker>(`/api/gebruikers/${id}/reset-wachtwoord`, {nieuw_wachtwoord}).then(r => r.data)
export const verwijderenGebruiker = (id: number) => api.delete(`/api/gebruikers/${id}`)

// ── Lijsten ──────────────────────────────────────────────────────────
export const fetchLijsten         = (orgId: number) => api.get<Record<string, string[]>>(`/api/lijsten/${orgId}`).then(r => r.data)
export const fetchLijstCategorie  = (orgId: number, cat: string) => api.get<LijstWaarde[]>(`/api/lijsten/${orgId}/${cat}`).then(r => r.data)
export const lijstWaardeToevoegen = (orgId: number, categorie: string, waarde: string) =>
  api.post<LijstWaarde>(`/api/lijsten/${orgId}`, {categorie, waarde}).then(r => r.data)
export const lijstWaardeVerwijderen = (orgId: number, id: number) => api.delete(`/api/lijsten/${orgId}/${id}`)

// ── Mutatielog ───────────────────────────────────────────────────────
export const fetchMutatielog = (params: { org_id?: number, actie?: string, entiteit?: string, zoek?: string, limit?: number } = {}) =>
  api.get<Mutatie[]>('/api/mutatielog', {params}).then(r => r.data)
export const downloadMutatielogCsvUrl = (orgId?: number) =>
  `/api/mutatielog/export.csv${orgId ? `?org_id=${orgId}` : ''}`
